import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import Quagga from 'quagga';
import Scanner from '../../components/Scanner/Scanner';
import { useProductActions } from 'modules/CustomerProducts/api';
export default function DeviceScannerContainer({ dpadIdsToActivate, productId, customerId, onClose, onActivation, onSerialNumberFound, }) {
    const { activateWithSerials } = useProductActions(customerId, productId);
    // List over completed activation requests
    const [results, setResults] = useState([]);
    // List over scanned serialNumbers
    const [scannerResults, setScannerResults] = useState([]);
    // This effect is used to coompare the scannedResults againts the results from the activation request
    useEffect(() => {
        const newResults = scannerResults.map(result => {
            const prev = results.find(r => r.serialNumber === result.serialNumber);
            if (!prev)
                return result;
            return Object.assign(Object.assign({}, result), { isActivated: result.isActivated || prev.isActivated, isFetching: false });
        });
        setScannerResults(newResults);
    }, [results, scannerResults]);
    const activateProduct = useCallback((requestBody, newScannerList) => {
        activateWithSerials(requestBody, {
            onSuccess: () => {
                onClose();
                onActivation();
            },
            onError: error => {
                var _a, _b;
                const serverData = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : [];
                const invalid = Array.isArray(serverData) ? serverData.filter(d => !d.isValid) : [];
                const invalidSerials = invalid.map(x => x.serialNumber);
                const updated = newScannerList.map(item => (Object.assign(Object.assign({}, item), { isActivated: invalidSerials.includes(item.serialNumber), isFetching: false })));
                onSerialNumberFound(updated.filter(i => i.isActivated), serverData);
                setResults(updated);
            },
        });
    }, [activateWithSerials, onActivation, onClose]);
    /**
     * Barcode detected handler
     */
    const onDetected = useCallback(result => {
        const code = result.codeResult.code.toUpperCase();
        const exists = scannerResults.some(s => s.serialNumber === code);
        if (exists)
            return;
        const valid = /^[A-Z0-9]*$/.test(code);
        if (!valid)
            return;
        Quagga.offDetected(onDetected);
        const newScan = {
            serialNumber: code,
            isActivated: false,
            isFetching: true,
        };
        const newList = [...scannerResults, newScan];
        setScannerResults(newList);
        const requestBody = dpadIdsToActivate.map(id => ({
            dpadId: id,
            serialNumbers: newList.map(x => x.serialNumber),
        }));
        activateProduct(requestBody, newList);
    }, [scannerResults, activateProduct, dpadIdsToActivate]);
    useEffect(() => {
        Quagga.onDetected(onDetected);
        return () => Quagga.offDetected(onDetected);
    }, [onDetected]);
    return (_jsx(Scanner, { results: scannerResults, onDetected: onDetected, onHeaderClick: onClose, totalDevices: dpadIdsToActivate.length }));
}
DeviceScannerContainer.propTypes = {
    dpadIdsToActivate: PropTypes.arrayOf(PropTypes.number).isRequired,
    productId: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
    onActivation: PropTypes.func.isRequired,
    onSerialNumberFound: PropTypes.func,
    customerId: PropTypes.number.isRequired,
};
